/** Адреса сессии агента (CLAUDE.md §7: URL строкой — только в `api/urls.ts`). */
export const OWN_AGENT_URLS = {
  /** `POST { agentInstanceId }` — токен рабочего места для запущенного агента (KA3). */
  token: '/api/platform/v1/me/agent-token',
} as const
